export const UPDATE_SM_INIT = 'UPDATE_SM_INIT';
export const UPDATE_SM_DONE = 'UPDATE_SM_DONE';
export const UPDATE_SM_FAILED = 'UPDATE_SM_FAILED';
export const RESET_CHANGES = 'RESET_CHANGES';
export const HAS_CHANGES = 'HAS_CHANGES';
export const UPDATE_SLA_DONE = 'UPDATE_SLA_DONE';
export const GET_TEMPLATE_LIST = 'GET_TEMPLATE_LIST';
export const UPDATE_SM_BUSINESS_HOUR_TEMPLATE ='UPDATE_SM_BUSINESS_HOUR_TEMPLATE';
export const SET_SM_PROPERTY = 'SET_SM_PROPERTY'